import React, { useRef, useState, useEffect } from 'react';
import {
	BrowserRouter as Router,
	Switch,
	Route,
	Link,
	useHistory
} from "react-router-dom";
import { createBrowserHistory } from "history";

import MapView from './components/MapView';
import Slider from './components/Slider';

import 'nouislider/dist/nouislider.css';

import helpers from './helpers.js';

function App() {
	const router = useRef(null);
	const [data, setData] = useState(null);
	const [selectedBird, setSelectedBird] = useState(null);
	const [infoPanelOpen, setInfoPanelOpen] = useState(false);

	const [winterData, setWinterData] = useState(null);
	const [summerData, setSummerData] = useState(null);
	const [nestingData, setNestingData] = useState(null);
	const [nestingMainData, setNestingMainData] = useState(null);

	useEffect(() => {
		if (!data) {
			fetch('data/fuglar.json')
				.then(res => res.json())
				.then((json) => {
					setData(json);
				})

		}
	})

	const [searchValue, setSearchValue] = useState('');

	const circleWidth = 300;
	let circumference = (2*Math.PI)*(circleWidth/2);

	let getMonthShortName = (monthNo) => {
		const date = new Date();
		date.setMonth(monthNo - 1);

		return date.toLocaleString('en-US', { month: 'short' });
	};

	console.log(selectedBird)

	return (
		<div className="App">
			<Router ref={router}>

				<Route url="*" render={(routeParams) => {
					let searchParams = helpers.parseSearchParams(routeParams.location.search);

					let sliderStart;

					if (searchParams.timabil) {
						try {
							let timabil = searchParams.timabil.split(';');

							sliderStart = timabil;
						}
						catch(e) {}
					}

					return <React.Fragment>
						<MapView searchParams={routeParams.location.search} selectedBird={selectedBird} onData={(data) => {
							console.log('onData')
							console.log(data)
							setWinterData(data.winterData);
							setSummerData(data.summerData);
							setNestingData(data.nestingData);
							setNestingMainData(data.nestingMainData);
						}} />

						<div className="bird-list">
							{
								data && data.map((item, index) => <a key={index} className={selectedBird && selectedBird.name == item.name ? 'selected' : ''} onClick={() => setSelectedBird(item)}>
									<div className="thumb" style={{backgroundImage: 'url('+item.image_wikimedia+')'}} />
									<div>
										{item.label}<br/>
										<small>{item.latin}</small>
									</div>
								</a>)
							}
						</div>

						<div className={'year-circle'+(selectedBird ? ' visible' : '')}>
							{
								selectedBird && <a href={selectedBird.url} className="image-link" style={{backgroundImage: 'url('+selectedBird.image_wikimedia+')'}}><span>{selectedBird.label}</span></a>
							}
							<div className="months">
								{
									(Array(24).fill(0.5).map((x, y) => x + y/2)).map(month => {
										return <div key={month} data-month={month}
											className={'month'+(winterData && winterData.indexOf(month) > -1 ? ' vinter' : '')+
												(summerData && summerData.indexOf(month) > -1 ? ' summer' : '')+
												(nestingData && nestingData.indexOf(month) > -1 ? ' nesting' : '')+
												(nestingMainData && nestingMainData.indexOf(month) > -1 ? ' nesting-main' : '')
											}
											style={{
												transform: 'rotate('+(((month/12)*360)-7)+'deg)',
												width: circumference/24
											}}>
												<div className="month-inner">

												</div>
										</div>
									})
								}
							</div>

							<div className="labels">
								{
									(Array(12).fill(1).map((x, y) => x + y)).map(month => <div key={month}
										className={'label'}
										style={{
											transform: 'rotate('+((month/12)*360)+'deg)',
											width: circumference/12
										}}>
											<div className="label-inner">
												{getMonthShortName(month)}
											</div>
									</div>)
								}
							</div>

						</div>

						<div className={'info-panel'+(infoPanelOpen ? ' open' : '')}>

							<div className="button" onClick={() =>  setInfoPanelOpen(!infoPanelOpen)}>{infoPanelOpen ? 'x' : '!'}</div>

							<div className="content">
								<h1>Farfuglakort</h1>
								<p>Þetta kort sýnir vetrarstöðvar ýmissa farfugla sem verpa á Íslandi eða hafa hér viðkomu. Á kortinu má sjá vetrarstöðvar merktar með rauðu og sumardvalarstaði merkta með gulu. Á skífunni má svo sjá hvenær á árinu fuglarnir eru hér á landi og hvenær þeir eru á ferðinni auk þess sem varptímabil er merkt með bleiku. Gögnin eru unnin upp úr gögnum á <a href="https://fuglavefur.is/" target="_blank">Fuglavefnum</a> sem <a href="http://www.johannoli.is/" target="_blank">Jóhann Óli Hilmarsson</a> gerði fyrir Menntamálastofnun.<br/>Þessi vefsíða ásamt kortinu er forrituð af <a href="https://eggald.in" target="_blank">Trausta Dagssyni</a>.</p>
							</div>

						</div>

						<div className="site-header" style={{
							position: 'relative',
							display: 'none',
							top: 20,
							left: 20,
							right: 20,
							zIndex: 1000
						}}>

{/*
format={/*{
	to: (value) => {
		let dateStr = (new Date(value)).toISOString().split('-');
		return parseInt(dateStr[1])+','+parseInt(dateStr[0]);
	},
	from: Number
}
*/}


							<Slider rangeMin={1}
							 	rangeMax={12}
								start={sliderStart}
								onChange={(event) => {
									let newSearchParams = helpers.updateSearchParams(router.current.history.location.search, {
										timabil: event.target.value.map(v => Math.round(v)).join(';'),
										stadsetning: null,
										sida: null
									});
									router.current.history.push({
										pathname: router.current.history.location.pathname,
										search: newSearchParams
									});
								}} />

						</div>
					</React.Fragment>
				}} />
			</Router>
		</div>
	);
}

export default App;
